import React from "react";
// 1. Import the Link component
import { Link } from "react-router-dom";
import logo from "./images/cresco.png";

function Navbar() {
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">
                    <img
                        src={logo}
                        alt="Cresco logo"
                        height="45"
                        className="d-inline-block align-top me-2"
                    />
                </Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            {/* 2. Replace a with Link, and href with to */}
                            <Link
                                className="nav-link active"
                                aria-current="page"
                                to="/"
                            >
                                Home Page
                            </Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link className="nav-link" to="/products">
                                Products Page
                            </Link>
                        </li> */}
                        <li className="nav-item">
                            <Link className="nav-link" to="/contact">
                                Contact Us
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
